import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3297588696/src/octohealth-web/node_modules/next/dist/client/app-dir/link.js");
